import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Capabilities from "@/components/site/Capabilities";
import Workshop from "@/components/site/Workshop";
import Intelligence from "@/components/site/Intelligence";
import Sectors from "@/components/site/Sectors";
import Process from "@/components/site/Process";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-white text-[#0A0A0A]">
      <Navbar />
      <Hero />
      <Capabilities />
      <Workshop />
      <Intelligence />
      <Sectors />
      <Process />
      <Contact />
      <Footer />
    </main>
  );
}
